import { compose, range, reverse } from "ramda";
import { mapIndexed } from "ramda-adjunct";
import { memo, useEffect, useMemo, useState } from "react";
import { useSpring, animated } from "react-spring";
import randomInt from "./functions/randomInt";
import { moveLittle } from "./moveLittle";

export const Option = memo(({ nth, percentage }) => {
  const bunQuantity = Math.round(percentage * 0.2);
  const numberOfRows = Math.round(bunQuantity / 2);
  const bunsInFirstRow = Math.round(numberOfRows);
  const [percentage_, setPercentage_] = useState(percentage);

  const randomBunsSeed = useMemo(
    () => range(0, 10).map(() => range(0, 10).map(() => ({
      x: randomInt(0)(20),
      y: randomInt(0)(20),
      r: randomInt(-50)(50),
    }))
    ),
    []
  );

  const randomBunsIndex = useMemo(
    () => range(0, 10).map(() => range(0, 10).sort(() => Math.random() - 0.5)),
    []
  );

  const percentageAnimationProps = useSpring({
    from: { val: percentage, x: 0 },
    to: { val: percentage_, x: percentage_ },
    config: { round: true },
  });

  useEffect(() => setPercentage_(percentage), [percentage]);

  return (
    <div className={`option option-${nth}`}>
      <animated.div
        className="percentage"
        style={{
          transform: percentageAnimationProps.x
            .to({ range: [0, 100], output: [5, 20] })
            .to((x) => `translate(-50%, -${x + 2}vw`),
        }}
      >
        <animated.div>{percentageAnimationProps.val}</animated.div>%
      </animated.div>

      {compose(
        reverse,
        mapIndexed((row, rowIndex) => (
          <div key={rowIndex} className="row">
            {range(0, 10).map((bun, movedBunIndex) => {
              const bunIndex = randomBunsIndex[rowIndex][movedBunIndex];
              const bunData = randomBunsSeed[rowIndex][bunIndex];

              return (
                <animated.div
                  key={movedBunIndex}
                  className="bun"
                  style={{
                    opacity: rowIndex <= numberOfRows &&
                      bunIndex < bunsInFirstRow - rowIndex
                      ? 1
                      : 0,

                    width: rowIndex <= numberOfRows &&
                      bunIndex < bunsInFirstRow - rowIndex
                      ? undefined
                      : 0,

                    transform: `scale(1.2) rotate(${moveLittle(
                      -50,
                      50,
                      bunData.r
                    )}deg) translate(${moveLittle(
                      0,
                      20,
                      bunData.x
                    )}px, ${moveLittle(0, 20, bunData.y)}px)`,
                  }} />
              );
            })}
          </div>
        ))
      )(range(0)(10))}
    </div>
  );
});
